import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPermissions } from '../../actions/permissionAction';
import './CmsPermission.scss';
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";
import Loader from '../loaderComponent/Loader';

const CMSPermission = ({ onPermissionsChange, selectedPermissionIds }) => {
    const [selectedPermissions, setSelectedPermissions] = useState({});
    const [permissionsData, setPermissionsData] = useState({});
    const dispatch = useDispatch();
    const { i18n, t } = useTranslation();
    const language = Cookies.get("language");
    const { loading, permissions, error } = useSelector((state) => state.permissions);

    useEffect(() => {
        handleChangeLanguage(language);
        dispatch(fetchPermissions());
    }, [dispatch]);

    useEffect(() => {
        if (permissions?.data) {
            setPermissionsData(permissions.data ?? {});
        }
    }, [permissions]);

    const handleChangeLanguage = (language) => {
        i18n.changeLanguage(language);
    };

    useEffect(() => {
        if (Array.isArray(selectedPermissionIds)) {
            const initialPermissions = {};
            selectedPermissionIds.forEach((id) => {
                if (id != null) initialPermissions[id] = true;
            });
            setSelectedPermissions(initialPermissions);
        }
    }, [selectedPermissionIds]);

    const updateSelectedPermissions = (updatedPermissions) => {
        const selectedIds = Object.keys(updatedPermissions).filter((id) => updatedPermissions[id]).map(id => parseInt(id));
        onPermissionsChange(selectedIds);
    };

    const toggleSinglePermission = (id) => {
        if (id == null) return;
        setSelectedPermissions((prev) => {
            const updatedPermissions = {
                ...prev,
                [id]: !prev[id],
            };
            updateSelectedPermissions(updatedPermissions);
            return updatedPermissions;
        });
    };

    const toggleNestedGroup = (nestedPermissions) => {
        if (!Array.isArray(nestedPermissions)) return;
        setSelectedPermissions((prev) => {
            const allSelected = nestedPermissions.every((perm) => prev[perm?.id]);
            const updatedPermissions = { ...prev };

            nestedPermissions.forEach((perm) => {
                if (perm?.id != null) updatedPermissions[perm.id] = !allSelected;
            });
            updateSelectedPermissions(updatedPermissions);
            return updatedPermissions;
        });
    };

    return (
        <div className="cms-permission-container">
            {loading ? (
                <Loader />
            ) : (
                Object.keys(permissionsData).map((topLevelKey) => (
                    <div key={topLevelKey} className="permission-group">
                        {permissionsData[topLevelKey] && typeof permissionsData[topLevelKey] === 'object' ? (
                            Object.keys(permissionsData[topLevelKey])?.map((nestedKey) => (
                                <div key={nestedKey} className="nested-permission-group">
                                    <h5 className="nested-permission-group-title">
                                        <input
                                            type="checkbox"
                                            id={`nestedKey-${nestedKey}`}
                                            checked={permissionsData[topLevelKey][nestedKey].every(
                                                (perm) => selectedPermissions[perm?.id]
                                            )}
                                            onChange={() =>
                                                toggleNestedGroup(permissionsData[topLevelKey][nestedKey])
                                            }
                                        />
                                        <label htmlFor={`nestedKey-${nestedKey}`}>{nestedKey}</label>
                                    </h5>
                                    {Array.isArray(permissionsData[topLevelKey][nestedKey]) &&
                                        permissionsData[topLevelKey][nestedKey]?.length > 0 ? (
                                        <div className="permission-flex">
                                            {permissionsData[topLevelKey][nestedKey]?.map((permission) => (
                                                <div key={permission?.id} className="permission-item">
                                                    <input
                                                        type="checkbox"
                                                        id={`permission-${permission?.id}`}
                                                        checked={!!selectedPermissions[permission?.id]}
                                                        onChange={() =>
                                                            toggleSinglePermission(permission?.id)
                                                        }
                                                    />
                                                    <label
                                                        className="cms-permission-label"
                                                        htmlFor={`permission-${permission?.id}`}
                                                    >
                                                        {permission?.display_name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p>{t('RolesAndPermission.noPermission')}{nestedKey}.</p>
                                    )}
                                </div>
                            ))
                        ) : (
                            <p>{t('RolesAndPermission.noPermission')} {topLevelKey}.</p>
                        )}
                    </div>
                ))
            )}
        </div>
    );
};

export default CMSPermission;
